import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import LanguageSelectorDesktop from '../desktop/atomicDesignDesktop/LanguageSelectorDesktop';
import LanguageSelectorMobile  from '../mobile/atomicDesignMobile/atoms/LanguageSelectorMobile';
import { useUrlContext }       from '../../contexts/UrlContext';

const MOBILE_BREAKPOINT = 768;           // < 768 px ⇒ mobile

const HeaderResponsivePart: React.FC = () => {
  const { t } = useTranslation();
  const { redirectToContactUsPart, redirectToHomePart, goBackWithFallback} = useUrlContext();

  const isMobile = useMediaQuery({ maxWidth: MOBILE_BREAKPOINT - 1 });

  /* dimensions adaptatives */
  const iconW        = isMobile ? '1.25rem' : '0.8rem';   // ~20 / 24 px
  const logoMaxW     = isMobile ? '25vw'   : '10vw';
  // const logoClamp    = { maxWidth: 120, minWidth: 90 };
  const fontSizeBack = isMobile ? '0.7rem' : '0.9rem';
  const gapRight     = isMobile ? '0.75rem' : '2.5rem';

  return (
    <header
      style={{
        width: '100%',
        maxWidth : isMobile ? '100vw' : '95vw',
        height : 90,
        padding: isMobile ? '20px 8px 0px' : '10px 32px 0',
        display: 'flex',
        alignItems: 'center',
        background: '#FFFFFF',
        fontFamily: 'Montserrat, sans-serif',
        position: 'relative',               // ← permet de centrer le logo
        boxSizing: 'border-box',
      }}
    >
      {/* --------- zone gauche: Retour --------- */}
      <button
        type="button"
        onClick={goBackWithFallback}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.4rem',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          zIndex: 2,                        // au‑dessus du logo
          marginLeft : isMobile ? 6 : 0
        }}
      >
        <img src="/images/chevron-left.svg" alt="back" style={{ width: iconW }} />
        <span style={{ fontSize: fontSizeBack, color: '#323E48', fontWeight: 200 }}>
          {t('header:back')}
        </span>
      </button>

      {/* --------- Logo centré --------- */}
      <img
        src="/images/logo-VPauto-part.svg"
        alt="VPauto"
        onClick={redirectToHomePart}
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          width: logoMaxW,
          // maxWidth: logoClamp.maxWidth,
          // minWidth: logoClamp.minWidth,
          height: 'auto',
          cursor: 'pointer',
        }}
      />

      {/* --------- zone droite: langue / contact --------- */}
      {isMobile ? (
        <div style={{ marginLeft: 'auto', zIndex: 2 }}>
          <LanguageSelectorMobile />
        </div>
      ) : (
        <div
          style={{
            marginLeft: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: gapRight,
            zIndex: 2,
          }}
        >
          <button
            type="button"
            onClick={redirectToContactUsPart}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '0.8rem',
              fontWeight: 700,
              color: '#323E48',
              padding: 0,
              whiteSpace: 'nowrap',
            }}
          >
            {t('header:contactUs')}
          </button>

          <LanguageSelectorDesktop />
        </div>
      )}
    </header>
  );
};

export default HeaderResponsivePart;
